import React from 'react';
import ContactForm from './ContactForm';
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

const Contacts = () => {
  const socialLinks = [
    { name: 'GitHub', icon: GitHubIcon, url: 'https://github.com/netsplatter' },
    { name: 'LinkedIn', icon: LinkedInIcon, url: 'https://linkedin.com/' },
    { name: 'mraccoondev@gmail.com', icon: EmailIcon, url: 'mailto:mraccoondev@gmail.com' },
  ]

  return (
    <section className="contacts" id="contacts">
      <div className="wrapper">
        <h2>Contact me</h2>
        <div className="contacts-content">
          <div className="social-links">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                className="social-icon"
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <social.icon />
                <span>{social.name}</span>
              </a>
            ))}
          </div>
          <div className="message-form">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
